import APIClient from "web_modules/APIClient";
import { ConditionStatus } from "@eave/shared/types/api";

const initialState = {
  conditions: [],
};

const KEY = "@borrower/conditions/";
const RESPOND_TO_CONDITION = `${KEY}RESPOND_TO_CONDITION`;
const GET_CONDITIONS = `${KEY}GET_CONDITIONS`;
const CREATE_CONDITION = `${KEY}CREATE_CONDITION`;
const CREATE_CONDITION_COMMENT = `${KEY}CREATE_CONDITION_COMMENT`;
const RECEIVE_CONDITION_COMMENT = `${KEY}RECEIVE_CONDITION_COMMENT`;
const MARK_COMMENT_READ = `${KEY}MARK_COMMENT_READ`;

export const respondToCondition = id => dispatch =>
  APIClient.patch(`/br/conditions/${id}`, { status: ConditionStatus.ReadyToReview }).then(
    (resp: any) => {
      dispatch({
        type: RESPOND_TO_CONDITION,
        condition: resp.condition,
      });
    },
  );

export const getConditions = () => dispatch =>
  APIClient.get(`/br/conditions`).then((resp: any) => {
    dispatch({
      type: GET_CONDITIONS,
      conditions: resp.conditions,
    });
  });

export const createCondition = condition => dispatch =>
  APIClient.post(`/br/conditions`, condition).then((resp: any) => {
    dispatch({
      type: CREATE_CONDITION,
      condition: resp.condition,
    });

    return resp.condition;
  });

export const createConditionComment = (id, message, internal = false) => dispatch =>
  APIClient.post(`/messages/condition/${id}`, { message, internal }).then((resp: any) => {
    dispatch({
      id,
      message: resp.message,
      type: CREATE_CONDITION_COMMENT,
    });
  });

export const commentReceived = message => dispatch =>
  dispatch({
    message,
    type: RECEIVE_CONDITION_COMMENT,
  });

export const markCommentAsRead = (
  applicationID: number,
  conditionID: number,
  messageID: number,
) => dispatch => {
  APIClient.post(`/${applicationID}/messages/${messageID}/read`, {}).then(() => {
    dispatch({
      conditionID,
      messageID,
      type: MARK_COMMENT_READ,
    });
  });
};

interface HasID {
  id: Number;
}
const appendIfNotPresent = (elems: HasID[] = [], newElem: HasID) => {
  if (elems.findIndex(e => e.id === newElem.id) > 0) {
    return elems;
  }
  return [...elems, newElem];
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case RESPOND_TO_CONDITION:
      return {
        ...state,
        conditions: state.conditions.map(condition => {
          if (condition.id === action.condition.id) {
            return {
              ...condition,
              status: action.condition.status,
            };
          }
          return condition;
        }),
      };
    case GET_CONDITIONS:
      return {
        ...state,
        conditions: action.conditions,
      };
    case CREATE_CONDITION:
      return {
        ...state,
        conditions: [...state.conditions, action.condition],
      };
    case CREATE_CONDITION_COMMENT:
      return {
        ...state,
        conditions: state.conditions.map(condition => {
          if (condition.id === action.id) {
            return {
              ...condition,
              message_thread_id: action.message.thread_id,
              messages: appendIfNotPresent(condition.messages, action.message),
            };
          }
          return condition;
        }),
      };
    case RECEIVE_CONDITION_COMMENT:
      return {
        ...state,
        conditions: state.conditions.map(condition => {
          if (condition.message_thread_id === action.message.thread_id) {
            return {
              ...condition,
              messages: appendIfNotPresent(condition.messages, action.message),
            };
          }
          return condition;
        }),
      };
    case MARK_COMMENT_READ:
      return {
        ...state,
        conditions: state.conditions.map(condition => {
          if (condition.id === action.conditionID) {
            return {
              ...condition,
              messages: condition.messages.map(message => {
                if (message.id === action.messageID) {
                  return {
                    ...message,
                    read_by_borrower: true,
                  };
                }
                return message;
              }),
            };
          }
          return condition;
        }),
      };
    default:
      return state;
  }
};

export default reducer;
